import { takeLatest, put, all, call } from "redux-saga/effects";
import appKeyActionTypes from "./appKeyActionTypes";
import { requestERPLYData, partnerKey } from "../../utils";
import { saveAccountLang } from "./appKeyActions";
import Server from "../../service/Server";

export function* getAccountConfig({
  payload: { sessionKey, clientCode, pageLang },
}) {
  console.log("pageLang", pageLang);
  const request = {
    request: "getConfParameters",
    sessionKey,
    clientCode,
    sendContentType: 1,
    partnerKey,
  };

  try {
    const response = yield call(requestERPLYData, request);

    if (response.data.status.responseStatus === "error") {
      yield put({
        type: appKeyActionTypes.GET_ACCOUNT_CONFIG_FAILED,
        payload: response.data.status,
      });
    } else {
      yield put(saveAccountLang({ ...response.data.records[0], pageLang }));
    }
  } catch (error) {
    yield put({
      type: appKeyActionTypes.GET_ACCOUNT_CONFIG_FAILED,
      payload: error,
    });
  }
}

export function* onGetAccountConfigStart() {
  yield takeLatest(
    appKeyActionTypes.GET_ACCOUNT_CONFIG_START,
    getAccountConfig
  );
}

export function* getUserRights({ payload: { sessionKey, clientCode } }) {
  const request = {
    request: "getUserRights",
    sessionKey,
    clientCode,
    sendContentType: 1,
    getCurrentUser: 1,
    partnerKey,
  };

  try {
    const response = yield call(requestERPLYData, request);
    if (response.data.status.responseStatus === "error") {
      yield put({
        type: appKeyActionTypes.GET_USER_RIGHTS_FAILED,
      });
    } else {
      yield put({
        type: appKeyActionTypes.GET_USER_RIGHTS_SUCCESS,
        payload: response.data.records[0],
      });
    }
  } catch (error) {
    yield put({
      type: appKeyActionTypes.GET_USER_RIGHTS_FAILED,
    });
  }
}

export function* getUserLanguages({ payload: { sessionKey, clientCode } }) {
  const request = {
    request: "getActiveLanguages",
    sessionKey,
    clientCode,
    sendContentType: 1,
    partnerKey,
  };
  try {
    const response = yield call(requestERPLYData, request);

    if (response.data.status.responseStatus === "error") {
      yield put({
        type: appKeyActionTypes.GET_USER_LANG_FAILED,
      });
    } else {
      yield put({
        type: appKeyActionTypes.GET_USER_LANG_SUCCESS,
        payload: response.data.records,
      });
    }
  } catch (error) {
    yield put({
      type: appKeyActionTypes.GET_USER_LANG_FAILED,
    });
  }
}

export function* getSessionUser({ payload: { sessionKey, clientCode } }) {
  const request = {
    request: "getSessionKeyUser",
    sessionKey,
    clientCode,
    sendContentType: 1,
    partnerKey,
  };
  try {
    const response = yield call(requestERPLYData, request);

    if (response.data.status.responseStatus === "error") {
      yield put({
        type: appKeyActionTypes.GET_SESSION_USER_FAILED,
      });
    } else {
      yield put({
        type: appKeyActionTypes.GET_SESSION_USER_SUCCESS,
        payload: response.data.records[0],
      });
    }
  } catch (error) {
    yield put({
      type: appKeyActionTypes.GET_SESSION_USER_FAILED,
    });
  }
}

export function* getFieldsPermission({ payload: { groupID } }) {
  try {
    const response = yield call(
      Server.getProductFieldSettings,
      null,
      null,
      groupID
    );
    yield put({
      type: appKeyActionTypes.GET_FIELD_PERMISSIONS_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put({
      type: appKeyActionTypes.GET_FIELD_PERMISSIONS_FAILED,
    });
  }
}

export function* getFranchiseInfo({
  payload: { sessionKey, clientCode, adminBaseUrl },
}) {
  try {
    const response = yield call(Server.getFranchiseInfo, adminBaseUrl, {
      sessionKey,
      clientCode,
    });

    yield put({
      type: appKeyActionTypes.GET_FRANCHAISE_SUCCESS,
      payload: response.data.data,
    });
  } catch (error) {
    yield put({
      type: appKeyActionTypes.GET_FRANCHAISE_FAILED,
    });
  }
}

export function* onGetFranchiseInfoStart() {
  yield takeLatest(appKeyActionTypes.GET_FRANCHAISE_START, getFranchiseInfo);
}

export function* onGetSessionUserSuccess() {
  yield takeLatest(
    appKeyActionTypes.GET_SESSION_USER_SUCCESS,
    getFieldsPermission
  );
}

export function* onGetSessionUserStart() {
  yield takeLatest(appKeyActionTypes.GET_SESSION_USER_START, getSessionUser);
}

export function* onGetUserLangsStart() {
  yield takeLatest(appKeyActionTypes.GET_USER_LANG_START, getUserLanguages);
}

export function* onGetUserRightsStart() {
  yield takeLatest(appKeyActionTypes.GET_USER_RIGHTS_START, getUserRights);
}

export function* appKeySagas() {
  yield all([
    call(onGetAccountConfigStart),
    call(onGetUserRightsStart),
    call(onGetUserLangsStart),
    call(onGetSessionUserStart),
    call(onGetSessionUserSuccess),
    call(onGetFranchiseInfoStart),
  ]);
}
